// Keeps customization-fee line item quantities in sync with the actual
// customized products in the cart. Whenever the cart changes (item added,
// removed, or quantity updated), this recalculates how many of each fee
// variant are actually needed and corrects the cart automatically —
// including removing a fee entirely if the item it belonged to was removed.
(function () {
  let isSyncing = false;
 
  function reconcile() {
    if (isSyncing) return;
    isSyncing = true;
 
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const desired = {}; // fee variant id -> total quantity needed
        const feeLines = {}; // fee variant id -> current quantity of that fee line
 
        cart.items.forEach((item) => {
          const props = item.properties || {};
          const feeId = props['_Fee Variant Id'];
          const isFeeLine = props['_Is Fee Line'] === 'true';
 
          if (isFeeLine) {
            feeLines[String(item.variant_id)] = item.quantity;
          } else if (feeId) {
            desired[String(feeId)] = (desired[String(feeId)] || 0) + item.quantity;
          }
        });
 
        const updates = {};
        let hasChanges = false;
 
        // Correct any existing fee line whose quantity doesn't match actual
        // demand — including setting it to 0 (removing it) if nothing in
        // the cart needs it anymore.
        Object.keys(feeLines).forEach((variantId) => {
          const target = desired[variantId] || 0;
          if (feeLines[variantId] !== target) {
            updates[variantId] = target;
            hasChanges = true;
          }
        });
 
        // Safety net: demand exists but no fee line found for it yet.
        Object.keys(desired).forEach((variantId) => {
          if (!(variantId in feeLines) && desired[variantId] > 0) {
            updates[variantId] = desired[variantId];
            hasChanges = true;
          }
        });
 
        // Cart attribute reflecting whether the cart genuinely contains a
        // personalized item right now (not just a customizable product —
        // only true once text or an image was actually submitted). Apps
        // like Simesy can condition on this attribute at checkout, which
        // is far more accurate than checking a static product tag.
        const hasPersonalization = Object.keys(desired).length > 0;
        const currentAttributeValue = (cart.attributes && cart.attributes['Has Personalization']) || '';
        const targetAttributeValue = hasPersonalization ? 'true' : '';
        const attributeNeedsUpdate = currentAttributeValue !== targetAttributeValue;
 
        if (!hasChanges && !attributeNeedsUpdate) {
          isSyncing = false;
          return;
        }
 
        const body = { updates: updates };
        if (attributeNeedsUpdate) {
          body.attributes = { 'Has Personalization': targetAttributeValue };
        }
 
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then(() => refreshCartDisplay());
      })
      .catch((e) => {
        console.error('Cart fee sync error:', e);
      })
      .finally(() => {
        isSyncing = false;
      });
  }
 
  function refreshCartDisplay() {
    const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;
 
    const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);
    return fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`)
      .then((response) => response.json())
      .then((sections) => {
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: sections });
        }
      });
  }
 
  // Re-check any time the theme announces a cart change (add, remove,
  // quantity update all publish this same event in this theme, when
  // available).
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      reconcile();
    });
  }
 
  // Direct, guaranteed fallback: re-check shortly after any click on a
  // cart remove button or quantity +/- control, regardless of whether the
  // event above actually fires for that action in this theme.
  document.addEventListener('click', function (e) {
    const removeTrigger = e.target.closest('cart-remove-button button');
    const quantityTrigger = e.target.closest('.quantity__button');
 
    if (removeTrigger) {
      // Let any personalize block on the current page know an item was
      // removed, so it can clear its own text/image input — otherwise the
      // old value would silently still be sitting in the input if the
      // customer adds the product again without reloading the page.
      document.dispatchEvent(new CustomEvent('wordsco:cart-item-removed'));
      setTimeout(reconcile, 900);
    } else if (quantityTrigger) {
      setTimeout(reconcile, 900);
    }
  });
 
  document.addEventListener('DOMContentLoaded', reconcile);
})();
 